import { getVisitorApprovalStatusBadgeConfig, getVisitorVisitStatusBadgeConfig } from "../functions/visitorHistoryStatus";
import type { ApprovalStatus, VisitStatus } from "src/api/visitor/visitor-types";
import type {
  VisitorHistoryBadgeConfig,
  VisitorHistoryCardStateConfig,
  VisitorVisitStatusBadgeOptions,
} from "../types/visitorHistoryStatus";

type VisitorHistoryBadgeProps = VisitorHistoryBadgeConfig;
const VisitorHistoryBadge = (props: VisitorHistoryBadgeProps) => {
  const { label, tone } = props;

  if (label === "-") {
    return <span>-</span>;
  }

  return <span className={`visitor-history-badge visitor-history-badge--${tone}`}>{label}</span>;
};

type VisitorVisitStatusBadgeProps = {
  visitStatus?: VisitStatus | null;
} & VisitorVisitStatusBadgeOptions;
export const VisitorVisitStatusBadge = (props: VisitorVisitStatusBadgeProps) => {
  const { visitStatus, hasAccessLog, isDeleted } = props;
  const badgeConfig = getVisitorVisitStatusBadgeConfig(visitStatus, { hasAccessLog, isDeleted });

  return <VisitorHistoryBadge {...badgeConfig} />;
};

type VisitorApprovalStatusBadgeProps = {
  approvalStatus?: ApprovalStatus | null;
};

export const VisitorApprovalStatusBadge = (props: VisitorApprovalStatusBadgeProps) => {
  const { approvalStatus } = props;
  const badgeConfig = getVisitorApprovalStatusBadgeConfig({ approvalStatus });

  return <VisitorHistoryBadge {...badgeConfig} />;
};

type VisitorHistoryCardStateLabelProps = {
  cardState?: VisitorHistoryCardStateConfig;
};
export const VisitorHistoryCardStateLabel = (props: VisitorHistoryCardStateLabelProps) => {
  const { cardState } = props;

  if (!cardState) return null;

  return <span className={`visitor-history-card-state visitor-history-card-state--${cardState.tone}`}>{cardState.label}</span>;
};
